<template>
  <CommonHeader class="c-switch-bar">
    <div class="tab">
      <!-- Queation type link. -->
      <!-- <RouterLink
        :replace="true"
        :exact="true"
        :class="{active: $route.path === '/question'}"
        class="item"
        to="/question"
      >
        {{ $t('question.q_a') }}
      </RouterLink> -->

      <!-- Tags type link. -->
      <!-- <RouterLink
        :replace="true"
        :exact="true"
        :class="{active: $route.path === '/question/topics'}"
        class="item"
        to="/question/topics"
      >
        {{ $t('question.topic.name') }}
      </RouterLink> -->
      {{ title || $t('question.qa') }}
    </div>

    <template slot="left">
      <RouterLink to="/search_list?type=question">
        <svg class="m-style-svg m-svg-def search-btn">
          <use xlink:href="#icon-search" />
        </svg>
      </RouterLink>
    </template>
    <template slot="right">
      <RouterLink to="/message/list">
        <div class="message" @click="goMessage">
          <BadgeIcon :count="unreadMessage+unreadAudits">
            <img src="../../../images/remind@2x.png" alt="">
          </BadgeIcon>
        </div>
      </RouterLink>
    </template>
  </CommonHeader>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'QuestionSwitchBar',
    props: ['title'],
    data () {
      return {
        notification: 1,
      }
    },
    computed: {
      ...mapGetters('message', {
        unreadMessage: 'unreadMessage',
        unreadAudits: 'unreadAudits',
      }),
    },
    methods: {
      goMessage () {
        this.$router.push({
          name: 'MessageHome',
        })
      },
    },
  }
</script>

<style lang="less" scoped>
.c-switch-bar {
  position: fixed;
  color:#fff;
  border-color: #dedede;
  z-index: 99;
  background-color: @tool-bar-bg;

  .search-btn {
    color:#fff;
  }

  .tab {
    display: inline-flex;

    .item {
      width: 125px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      box-sizing: content-box;
      border: solid 1px @primary; /* no */
      color: @primary;
      font-size: 32px;

      &.active {
        background: @primary;
        color: #fff;
      }

      &:last-child {
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
      }

      &:first-child {
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
      }
    }
  }
    .message{
       width: 30px;
      img{
         width: 30px;
      }
    }
}
</style>
<style scoped>
.c-switch-bar  >>> .v-badge-count {
  top: -6px;
  right: -6px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: #D52B1E;
}
.m-svg-def {
  width: 32px;
  height: 32px;
}
.c-switch-bar >>> .right{
  width: 0;
  min-width: 0;
  margin-right: 21px;
}
</style>
